import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Any npm user can create an organization to manage contributor access to packages governed by the organization.`}</p>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` You need an npm user account to create an organization. To create a user account, visit the `}<a parentName="p" {...{
          "href": "https://www.npmjs.com/signup"
        }}>{`account signup page`}</a>{`".`}</p>
    </Note>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-create'].text}</>
        <>{shared['organization-create'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the organization creation page, in the `}<strong parentName="p">{`Name`}</strong>{` field, type a name for your organization. Your organization name will also be your organization scope.`}</p>
        <Screenshot src="/organizations/creating-and-managing-organizations/create-name.png" alt="Screenshot showing the new organization name field" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Under the `}<strong parentName="p">{`Name`}</strong>{` field, choose either the "Unlimited private packages" paid plan or the "Unlimited public packages" free plan and click `}<strong parentName="p">{`Buy`}</strong>{` or `}<strong parentName="p">{`Create`}</strong>{`.`}</p>
        <>{shared['billing-organization-plans'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`(Optional) On the organization invitation page, type the npm username or email address of a person you would like to add to your organization as a member and select a team to invite them to, then click `}<strong parentName="p">{`Invite`}</strong>{`.`}</p>
        <Screenshot src="/organizations/creating-and-managing-organizations/create-invite.png" alt="Screenshot showing the invitation options for a new organization" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Continue`}</strong>{`.`}</p>
        <Screenshot src="/organizations/creating-and-managing-organizations/create-confirm.png" alt="Screenshot showing the new organization confirmation" mdxType="Screenshot" />
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      